import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Container } from 'rsuite';
import { PageProps } from '../../../../../@types';
import { resetFiltersOptimizationResult } from '../../../../../reducers/OtimizacaoPrecos/optimizationPricesResult';
import { useCheckUserAllowAccess } from '../../hooks/useCheckUserAllowAccess';
import { HeaderResult } from './components/Header';
import { OptimizationTabs } from './components/OptimizationTabs';
import { ResultGroup } from './components/ResultGroup';
import styles from './OtimizacaoResultado.module.scss';

export type OtimizacaoResultadoProps = React.HTMLAttributes<HTMLElement> & PageProps;

const MemoOptimizationTabs = React.memo(OptimizationTabs);

export const OtimizacaoResultado = ({ usuario }: OtimizacaoResultadoProps) => {
  useCheckUserAllowAccess({ usuario });
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetFiltersOptimizationResult());
    };
  }, [dispatch]);

  return (
    <Container className="main-container ">
      <main className={styles.container}>
        <HeaderResult />
        <ResultGroup />
        <MemoOptimizationTabs />
      </main>
    </Container>
  );
};
